/** ***************************************************************************
 * Molecules / Canvas remote
 *************************************************************************** */

import CaptureModalComponent from '../modal/capture/capture';

class RemoteComponent {
  constructor(element, canvasComponent) {
    this.element = element;
    this.element.smRemote = this;
    this.element.classList.add('sm-m-js');

    this.setUpEventListeners();

    this.canvasComponent = canvasComponent;

    this.draw = this.element.querySelector('.sm-c-remote-button:nth-child(2)');
    this.drag = this.element.querySelector('.sm-c-remote-button:nth-child(1)');
    this.erase = this.element.querySelector('.sm-c-remote-button:nth-child(3)');

    this.draw.querySelector(':scope > input').onchange = (event) => {
      if (event.target.checked) {
        this.canvasComponent.activateTool('pencil');
      }
    };
    this.erase.querySelector(':scope > input').onchange = (event) => {
      if (event.target.checked) {
        this.canvasComponent.activateTool('eraser');
      }
    };
    this.drag.querySelector(':scope > input').onchange = (event) => {
      if (event.target.checked) {
        this.canvasComponent.deactivate();
      }
    };

    const body = document.querySelector('body');
    const captureDialogFragment = this.buildCaptureDialog();
    body.appendChild(captureDialogFragment);
    this.captureDialog = new CaptureModalComponent(
      body.lastElementChild,
      document.querySelector('.sm-c-canvas')
    );

    this.captureButton = this.element.querySelector('.sm-c-remote-button.sm-m-capture');
    this.captureButton.onclick = (event) => {
      event.preventDefault();
      this.captureDialog.open();
    };

    if (matchMedia('(pointer:coarse)').matches) {
      this.drag.click();
    } else {
      this.draw.click();
      this.canvasComponent.activateTool('pencil');  // Firefox needs this
    }

    document.addEventListener('supermatita:secret:answer', this.onanswer);
  }

  destroy() {
    this.draw.querySelector(':scope > input').onchange = undefined;
    this.erase.querySelector(':scope > input').onchange = undefined;
    this.drag.querySelector(':scope > input').onchange = undefined;
    document.removeEventListener('supermatita:secret:answer', this.onanswer);
    this.element.classList.remove('sm-m-js');
  }

  buildCaptureDialog() {
    const modalTemplate = document.getElementById('sm-c-modal-capture-template');
    return modalTemplate.content.cloneNode(true);
  }

  // Event listeners

  setUpEventListeners() {
    this.onanswer = (event) => {
      this.draw.click();
    };
  }
}


export { RemoteComponent as default };
